import { MainPage } from './pages/MainPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { SupportPage } from './pages/SupportPage';

function App() {
  const path = window.location.pathname.replace(/\/+$/, '');

  if (path === '/privacy') {
    return <PrivacyPage />;
  }

  if (path === '/support') {
    return <SupportPage />;
  }

  return <MainPage />;
}

export default App;
